export const learnMoreUrl =
  'https://help.paperlessparts.com/s/article/Found-in-files-extractions';
export const learnMoreClick = (event) => {
  //Prevent the accordianButton default behavior of expanding/collaposing accordian
  //And open the URL in new page
  //Still need `href, target and rel` attributes in case user right clicks on button
  window.open(learnMoreUrl, '_blank', 'noopener,noreferrer');
  event.preventDefault();
};
